import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, withHandlers, withStateHandlers, setPropTypes } from 'recompose';
import get from 'lodash/get';
import { fetchSearchPlayerCareer as apiFetchSearchPlayerCareer } from '../../../../../front-v2/services/api';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

function SelectStats({ selectValue = 'custom', tournamentsList = [], handleChange }) {
    return (
        <SelectField floatingLabelText="Season select" value={selectValue} onChange={handleChange} fullWidth>
            {/*<MenuItem key="Custom" value="custom" primaryText="Custom values" />*/}
            {tournamentsList.map(({ value = '', text = '' }) => (
                <MenuItem key={value} value={value} primaryText={text} />
            ))}
        </SelectField>
    );
}

SelectStats.propTypes = {
    selectValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tournamentsList: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default compose(
    setPropTypes({
        id: PropTypes.string.isRequired,
        valueDefault: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        propsStatsMap: PropTypes.objectOf(PropTypes.string).isRequired,
        updateWidgetJSPropField: PropTypes.func.isRequired,
    }),
    withStateHandlers(
        ({ valueDefault }) => ({
            loading: false,
            selectValue: valueDefault,
            stats: {},
            tournamentsList: [],
        }),
        {
            handleLoading: () => (loading = false) => ({ loading }),
            handleSelectValue: () => (selectValue = 'custom') => ({ selectValue }),
            handleStats: () => (stats = {}) => ({ stats }),
            handleTournamentsList: ({ selectValue }) => (tournamentsList = []) =>
                !selectValue && tournamentsList.length > 0
                    ? { tournamentsList, selectValue: tournamentsList[0] && tournamentsList[0].value }
                    : { tournamentsList },
        },
    ),
    withHandlers({
        loadCareer: ({ loading, handleTournamentsList, handleStats, handleLoading }) => playerId => {
            if (playerId == null) {
                return;
            }

            const controller = new AbortController();
            const signal = controller.signal;

            if (loading) {
                controller.abort();
            }

            handleLoading(true);

            apiFetchSearchPlayerCareer(playerId, signal)
                .then(({ stats = [] }) => {
                    stats = stats.filter(({ season: { year = '' } = { year: '' } }) =>
                        new RegExp(`${new Date().getFullYear()}`).test(`${year}`),
                    );

                    handleTournamentsList(
                        stats.map(({ tournament = {}, season = {} }) => ({
                            value: season.id,
                            text: `${tournament.name} ${season.year}`,
                        })),
                    );

                    handleStats(
                        stats.reduce((acc, { season = {}, stats = {} }) => ({ ...acc, [season.id]: stats }), {}),
                    );
                    handleLoading(false);
                })
                .catch(() => {
                    handleLoading(false);
                });
        },
        handleChange: ({ id, stats, propsStatsMap, updateWidgetJSPropField, handleSelectValue }) => (
            event,
            index,
            selectValue,
        ) => {
            handleSelectValue(selectValue);
            updateWidgetJSPropField(id, { selectValue });
            const statsPlayer = stats[selectValue];

            if (statsPlayer) {
                updateWidgetJSPropField(
                    id,
                    Object.entries(propsStatsMap).reduce(
                        (stats, [statName, key]) => ({ ...stats, [statName]: get(statsPlayer, key) }),
                        {},
                    ),
                );
            }
        },
    }),
    lifecycle({
        componentDidMount() {
            if (this.props.playerId) {
                this.props.loadCareer(this.props.playerId);
            }
        },
        componentWillReceiveProps({ playerId }) {
            if (playerId && this.props.playerId !== playerId) {
                this.props.loadCareer(playerId);
            }
        },
    }),
)(SelectStats);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/components/PlayerPicker/SelectStats.js
 **/